const languageListeners = new Set();

const i18nService = {
  defaultLanguage: "en",

  languages: [
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "assets/media/flags/226-united-states.svg",
    },
    {
      lang: "ptbr",
      name: "Português do Brasil",
      flag: process.env.BASE_URL + "assets/media/flags/255-brazil.svg",
    },
    {
      lang: "pt-pt",
      name: "Português (Portugal)",
      flag: process.env.BASE_URL + "assets/media/flags/224-portugal.svg",
    },
    {
      lang: "id",
      name: "Bahasa Indonesia",
      flag: process.env.BASE_URL + "assets/media/flags/209-indonesia.svg",
    },
    {
      lang: "es",
      name: "Español",
      flag: process.env.BASE_URL + "assets/media/flags/128-spain.svg",
    },
    {
      lang: "de",
      name: "Deutsche",
      flag: process.env.BASE_URL + "assets/media/flags/162-germany.svg",
    },
    {
      lang: "fr",
      name: "Français",
      flag: process.env.BASE_URL + "assets/media/flags/195-france.svg",
    },
  ],

  normalizeLanguage(lang) {
    if (typeof lang !== "string") {
      return "";
    }

    const normalized = lang.trim().toLowerCase().replace(/_/g, "-");
    const [language, region] = normalized.split("-");
    if (normalized === "ptbr" || (language === "pt" && region === "br")) {
      return "ptbr";
    }

    if (language === "pt") {
      return "pt-pt";
    }

    return this.languages.some(({ lang }) => lang === language) ? language : "";
  },

  getApiLanguage(lang) {
    const normalized = this.normalizeLanguage(lang) || this.getActiveLanguage();
    return normalized === "ptbr" ? "pt-br" : normalized;
  },

  /**
   * Persist the language and update the active translation instances.
   * @param lang
   */
  setActiveLanguage(lang) {
    const language = this.normalizeLanguage(lang) || this.getActiveLanguage();
    localStorage.setItem("language", language);
    languageListeners.forEach((listener) => listener(language));
  },

  onLanguageChanged(listener) {
    languageListeners.add(listener);
    return () => languageListeners.delete(listener);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    const storedLanguage = this.normalizeLanguage(
      localStorage.getItem("language")
    );
    if (storedLanguage) return storedLanguage;

    const browserLanguages =
      navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language];
    return (
      browserLanguages
        .map((language) => this.normalizeLanguage(language))
        .find(Boolean) || this.defaultLanguage
    );
  },
};

export default i18nService;
